import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)<{ backgroundImage: string }>`
  ion-content {
    background: url(${(props) => props.backgroundImage}) center/cover no-repeat;

    .content-wrapper {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 48px 16px 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      backdrop-filter: blur(3px);
    }

    .app-logo {
      margin-bottom: 20px;
    }

    .page-title {
      margin-bottom: 20px;
    }
  }
`;
